<template>
    <div class="container font-eng mb-5" style="width: 100%;height: 100%;">

        <div class="row no-gutter mt-5 mb-5 p-2">

            <div class="col-md-8 offset-md-2 rounded p-0" style="background-color: rgba(0,0,0,0.2);">

                <div class="bg-secondary p-2">
                    <strong class="text-pink">Login</strong>
                    <small class="float-right">
                        <samp class="material-icons text-danger mr-1">circle</samp>
                        <samp class="material-icons text-warning mr-1">circle</samp>
                        <samp class="material-icons text-pink mr-1">circle</samp>
                    </small>
                </div>

                <h6 class="ml-1 mt-3 text-warning" style="display: inline">root@Shine Shine : <span class="text-info" style="font-familyfont-size: 30px;">~$ </span></h6>

                <form @submit.prevent="check" style="display:inline;" class="bg-dark">
                    <input v-model="username_password" @keyup.enter.prevent="check" type="text" class="border-0 text-pink pl-1"  style="height:20px;background-color: rgba(0,0,0,0.2);outline: none;" v-focus>
                </form>
                <br/>
                <span class="text-pink">{{username_password}}</span>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data(){
            return {
                username_password : null,
            }
        },
        methods : {
            check(event){
                event.preventDefault();
                alert("ok");

            }

        }

    }
</script>

<style scoped>

</style>